export type DayStatus = 'neutral' | 'open' | 'closed';
export const DAY_STATUS: { [K in DayStatus]: K } = {
  neutral: 'neutral',
  open: 'open',
  closed: 'closed'
} as const;
export type DayIndex = number;
export type DuplicateDayEntry = {
  day: DayIndex;
  groups: number[];
};
